export default __webpack_public_path__ + "static/media/nust.f20643a0.png";